<template>
  <b-row>
    <b-col sm="12">
        <div v-if="pieOptions == null" class="text-center" style="font-size: 1em; padding: 100px 0px 100px;">
          <b-badge>There's no statistics data</b-badge>
        </div>
        <vue-highcharts v-else :options="pieOptions"></vue-highcharts>
    </b-col>
  </b-row>
</template>

<script>
import VueHighcharts from 'vue2-highcharts'
import * as initConfigChart from '@/views/components/charts/HighchartInit'
import axios from 'axios'

export default {
  name: 'visitorPieChart',
  components: {
    VueHighcharts
  },
  data () {
    return {
      apiPieStatsComplaint: window.AppConfig.apiUrl + 'complaint-stats',
      apiUrlComplaintStatus: window.AppConfig.apiUrl + 'complain-status',
      complaintStatusList: [],
      color: {
        'Pending': {
          'color': '#ffc107'
        },
        'In Progress': {
          'color': '#20a8d8'
        },
        'Resolved': {
          'color': '#4dbd74'
        }
      },
      pieOptions: null
    }
  },
  mounted () {
    try {
      this.getComplaintStats()
      this.doAutoRefresh()
    } catch (err) { window.consoleLog(err) }
  },
  beforeDestroy () {
    clearInterval(this.refComplaintPie)
  },
  methods: {
    getComplaintStats () {
      axios.get(this.apiUrlComplaintStatus).then(response => {
        if (response !== undefined) {
          let datas = response.data._embedded.complainStatus
          for (let i = 0; i < response.data.total_items; i++) {
            this.complaintStatusList[datas[i].name] = datas[i].uuid
          }
          axios.get(this.apiPieStatsComplaint)
            .then(response => {
              if (response === undefined) return false
              if (Object.keys(response.data).length) {
                // check all data is return 0
                // return null if yes
                let tmp = 0
                for (let key in response.data) tmp += parseInt(response.data[key])
                if (tmp !== 0) {
                  let dataChart = []
                  Object.keys(response.data).forEach(function (key) {
                    dataChart.push({
                      'name': key,
                      'y': parseInt(response.data[key]),
                      'sliced': dataChart.length === 0,
                      'selected': dataChart.length === 0
                    })
                  })
                  let opt = initConfigChart.pieOptions
                  opt.series = [{
                    name: 'data',
                    data: dataChart
                  }]
                  opt.colors = []
                  let self = this
                  opt.plotOptions.pie.point = {
                    events: {
                      click: function (e) {
                        self.redirectToPage(this.name)
                        return false
                      }
                    }
                  }
                  for (let i = 0; i < Object.keys(response.data).length; i++) {
                    opt.colors.push(this.color[Object.keys(response.data)[i]].color)
                  }
                  this.pieOptions = opt
                } else {
                  this.pieOptions = null
                }
              }
            })
            .catch(error => {
              this.$store.dispatch('errorMessage', error)
                .then(errMsg => {
                  this.$alertify.error(errMsg)
                })
            })
        }
      })
    },

    redirectToPage (statusName) {
      this.$router.push({ path: '/complaint', query: { 'complain_status_uuid': this.complaintStatusList[statusName] } })
    },

    doAutoRefresh () {
      this.refComplaintPie = setInterval(() => {
        this.getComplaintStats()
      }, window.AppConfig.IntervalRefreshData)
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/views/index/complaintPieChartByStatus.vue